import { render, staticRenderFns } from "./GdprFormItem.vue?vue&type=template&id=2672de7a&scoped=true&"
import script from "./GdprFormItem.vue?vue&type=script&lang=js&"
export * from "./GdprFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../BougeMaVille-reborn-client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2672de7a",
  null
  
)

export default component.exports